<template>
    <v-card flat class="sub-site-wrapper">
        <div v-if="customerStats" class="table-statistics-wrapper">
            <v-row>
                <v-col cols="12" sm="3">
                    <div v-if="customerStats" class="statistics-text-box elevation-3">
                        <h5>Gesamtzahl der Kunden auf der Datenbank:</h5>
                        <h3>{{ customerStats.totalCustomers }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="customerStats" class="statistics-text-box elevation-3">
                        <h5>Aktive Kunden:</h5>
                        <h3>{{ calcActiveCustomers }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="customerStats" class="statistics-text-box elevation-3">
                        <h5>Archivierte Kunden:</h5>
                        <h3>{{ customerStats.archivedCustomers }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="customerStats" class="statistics-text-box elevation-3">
                        <h5>Auf inaktiv gesetzte Kunden:</h5>
                        <h3>{{ customerStats.inactiveCustomers }}</h3>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="3">
                    <div v-if="customerStats" class="statistics-text-box elevation-3">
                        <h5>Durchschnittliche Kampagnen pro Kunde:</h5>
                        <h3>{{ customerStats.averageTablesLength.toFixed(2) }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="customerStats" class="statistics-text-box elevation-3">
                        <h5>Median der Kampagnen pro Kunde:</h5>
                        <h3>{{ customerStats.medianTablesLength }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="customerStats" class="statistics-text-box elevation-3">
                        <h5>Durchschnittliche Anzahl der Leads pro Kunde:</h5>
                        <h3>{{ customerStats.averageLeadsCombined.toFixed(2) }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="customerStats" class="statistics-text-box elevation-3">
                        <h5>Median der Leads pro Kunde:</h5>
                        <h3>{{ customerStats.medianLeadsCombined }}</h3>
                    </div>
                </v-col>

            </v-row>
            <v-row>
                <v-col cols="12" sm="3">
                    <div v-if="customerStats" class="statistics-text-box elevation-3">
                        <h5>Anzahl der in den letzten 30 Tagen kreierten Kunden:</h5>
                        <h3>{{ customerStats.createdLast30Days }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="customerStats" class="statistics-text-box elevation-3">
                        <h5>Anzahl der in den letzten 7 Tagen kreierten Kunden:</h5>
                        <h3>{{ customerStats.createdLast7Days }}</h3>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="statistics-text-box elevation-3">
                        <h5>Informationen zu den Statistiken:</h5>
                        <p>Es fließen nur Agenturen in die Statistik ein, die eine Stripe Subscription ID besitzen und
                            mindestens einen Slot haben.</p>
                        <p>Die Statistiken wurden am <b>{{ statisticsAge }}</b> erstellt.</p>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>

import { mapState, mapActions } from 'vuex';

export default {
    components: {

    },
    created() {
        this.loadStatistics();
    },
    computed: {
        ...mapState('statistics', ['customerStats', 'loading', 'statisticsAge']),
        calcActiveCustomers() {
            return this.customerStats.totalCustomers - this.customerStats.archivedCustomers - this.customerStats.inactiveCustomers;
        }   
    },
    methods: {
        ...mapActions('statistics', ['fetchMostRecentStatistic']),
        async loadStatistics() {
            await this.fetchMostRecentStatistic();
        },
    },
}

</script>

<style lang="scss" scoped>
.table-statistics-wrapper {
    padding: 24px;
}


.statistics-text-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    font-weight: 500;
    border: 1px solid rgb(196, 196, 196);
    border-radius: 12px;
    padding: 12px;
}
</style>